import { render, staticRenderFns } from "./create_platform.vue?vue&type=template&id=74dae80a&scoped=true"
import script from "./create_platform.vue?vue&type=script&lang=js"
export * from "./create_platform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dae80a",
  null
  
)

export default component.exports